import React from 'react'
import Link from 'next/link'
import KachLogo from './KachLogo'

export type NavigatorFC = React.FC<React.PropsWithChildren<{ href?: any }>>

export const UnexpectedErrorSCN = (props: { Navigator: NavigatorFC }) => {
  return (
    <div className='flex min-h-[100dvh] flex-col items-center justify-center gap-4 bg-background px-4 py-12 sm:px-6 lg:px-8'>
      <KachLogo size='7rem' variant='primary' />

      <div className='mx-auto max-w-md text-center'>
        <h1 className='text-4xl font-bold'>500</h1>
        <span className='mt-4 text-5xl font-bold tracking-tight text-foreground sm:text-4xl'>
          Algo salió mal
        </span>
        <p className='mt-4 text-muted-foreground'>
          El equipo de Kach ya fue notificado del error y lo solucionará lo
          antes posible. Disculpa por las molestias ocasionadas.
        </p>
        <div className='mt-6'>
          <Link
            href='/'
            className='inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
            prefetch={false}
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  )
}
